import { createFileRoute } from '@tanstack/react-router'
import { ScoringView } from '@/features/scoring/view'

export const Route = createFileRoute(
  '/_authenticated/scoring/$conversationId/view'
)({
  component: ScoringView,
})
